import { get } from 'lodash-es';
import { emptyObject } from 'ui-components/default-props/empty';

import type { LtlCoreState, WizardOpenConfig } from '../ltl.types';
import type { FreightTrackingDetail } from '@shipstation/client-common/types/freight-responses';
import type { RootState } from 'store/root-state';

export const selectIsWizardOpen = (state: LtlCoreState): boolean => get(state, 'isWizardOpen', false);
export const selectWizardOpenConfig = (state: LtlCoreState): WizardOpenConfig | null => get(state, 'wizardOpenConfig', null);
export const selectIsDownloadingDocument = (state: LtlCoreState): boolean => get(state, 'isDownloadingDocument', false);
export const selectIsFulfillmentTypeChanging = (state: LtlCoreState): boolean => get(state, 'isFulfillmentTypeChanging', false);
export const selectHasFulfillmentTypeError = (state: LtlCoreState): boolean => get(state, 'hasFulfillmentTypeError', false);
export const selectTrackingDetailsByShipmentId = (state: LtlCoreState): Record<number, FreightTrackingDetail> =>
  get(state, 'trackingDetailsByShipmentId', emptyObject);

export const selectLtlIsWizardOpen = (state: RootState): boolean => selectIsWizardOpen(get(state, 'ltl.core'));
export const selectLtlWizardOpenConfig = (state: RootState): WizardOpenConfig | null => selectWizardOpenConfig(get(state, 'ltl.core'));
export const selectLtlIsDownloadingDocument = (state: RootState): boolean => selectIsDownloadingDocument(get(state, 'ltl.core'));
export const selectLtlIsFulfillmentTypeChanging = (state: RootState): boolean => selectIsFulfillmentTypeChanging(get(state, 'ltl.core'));
export const selectLtlHasFulfillmentTypeError = (state: RootState): boolean => selectHasFulfillmentTypeError(get(state, 'ltl.core'));
export const selectLtlTrackingDetailsByShipmentId = (state: RootState): Record<number, FreightTrackingDetail> =>
  selectTrackingDetailsByShipmentId(get(state, 'ltl.core'));
